import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";
import { BRAND } from "../constants";

const links = [
  { label: "Servizi", to: "/servizi" },
  { label: "Marche", to: "/marche" },
  { label: "Come funziona", to: "/come-funziona" },
  { label: "Zone", to: "/zone" },
  { label: "Contatti", to: "/contatti" },
];

const linkCls = ({ isActive }) =>
  `font-mono-tech text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
    isActive ? "text-[#FF6B00]" : "text-[#94A3B8] hover:text-white"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-header" className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="mx-auto max-w-7xl px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group" onClick={() => setOpen(false)}>
          <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[8deg]" />
          <span className="font-display font-semibold text-lg tracking-tight">{BRAND}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.to.slice(1)}`} className={linkCls}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 rounded-full border border-white/15"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-white/10 glass" data-testid="mobile-nav">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.to.slice(1)}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 font-mono-tech text-sm uppercase tracking-[0.2em] border-b border-white/5 ${
                    isActive ? "text-[#FF6B00]" : "text-[#F1F5F9]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
